module.exports = "<p>\n  config-page works!\n</p>\n"